// Mock data for all wedding modules

// GUESTS MODULE
export const mockGuests = [
  {
    id: "g1",
    name: "Amit Sharma",
    email: "amit@email.com",
    phone: "+91 98765 43210",
    side: "Bride Side",
    guestCount: 4,
    rsvpStatus: "confirmed",
    mealPreference: "Vegetarian",
    hotelName: "The Grand Palace Hotel",
    roomNumber: "Deluxe 201",
    roomAllocation: "Deluxe 201",
    checkInDate: "2025-12-14",
    checkOutDate: "2025-12-16",
    transportRequired: true,
    transportDetails: "Pick up from airport at 3 PM on Dec 14",
    notes: "Allergic to peanuts. VIP guest from Mumbai."
  },
  {
    id: "g2",
    name: "Priya Mehta",
    email: "priya.mehta@email.com",
    phone: "+91 98765 43211",
    side: "Groom Side",
    guestCount: 2,
    rsvpStatus: "confirmed",
    mealPreference: "Jain",
    hotelName: "Taj Residency",
    roomNumber: "Suite 305",
    roomAllocation: "Suite 305",
    checkInDate: "2025-12-13",
    checkOutDate: "2025-12-16",
    transportRequired: false,
    transportDetails: "",
    notes: "Strictly Jain food required."
  },
  {
    id: "g3",
    name: "Rajesh Kumar",
    email: "rajesh@email.com",
    phone: "+91 98765 43212",
    side: "VIP",
    guestCount: 3,
    rsvpStatus: "pending",
    mealPreference: "Non-Vegetarian",
    hotelName: "Oberoi Palace",
    roomNumber: "Presidential Suite",
    roomAllocation: "Presidential Suite",
    checkInDate: "2025-12-14",
    checkOutDate: "2025-12-17",
    transportRequired: true,
    transportDetails: "Private car from Delhi",
    notes: "Company CEO. Needs special attention."
  },
  {
    id: "g4",
    name: "Anita Desai",
    email: "anita@email.com",
    phone: "+91 98765 43213",
    side: "Relatives",
    guestCount: 5,
    rsvpStatus: "confirmed",
    mealPreference: "Vegetarian",
    roomAllocation: "Deluxe 202",
    transportRequired: false,
    transportDetails: "",
    notes: "Coming with elderly parents. Need ground floor room."
  },
  {
    id: "g5",
    name: "Vikram Singh",
    email: "vikram@email.com",
    phone: "+91 98765 43214",
    side: "Friends",
    guestCount: 1,
    rsvpStatus: "declined",
    mealPreference: "Vegetarian",
    roomAllocation: "",
    transportRequired: false,
    transportDetails: "",
    notes: "Work commitment. Sent regrets."
  },
  {
    id: "g6",
    name: "Sneha Patel",
    email: "sneha@email.com",
    phone: "+91 98765 43215",
    side: "Bride Side",
    guestCount: 2,
    rsvpStatus: "maybe",
    mealPreference: "Vegan",
    roomAllocation: "",
    transportRequired: false,
    transportDetails: "",
    notes: "Waiting for flight confirmation."
  },
  {
    id: "g7",
    name: "Karan Malhotra",
    email: "karan@email.com",
    phone: "+91 98765 43216",
    side: "Groom Side",
    guestCount: 6,
    rsvpStatus: "confirmed",
    mealPreference: "Non-Vegetarian",
    hotelName: "The Grand Palace Hotel",
    roomNumber: "Deluxe 203-204",
    roomAllocation: "Deluxe 203-204",
    checkInDate: "2025-12-13",
    checkOutDate: "2025-12-16",
    transportRequired: true,
    transportDetails: "Group pickup from railway station",
    notes: "Large family group. Need adjacent rooms."
  },
  {
    id: "g8",
    name: "Dr. Sunita Verma",
    email: "sunita@email.com",
    phone: "+91 98765 43217",
    side: "VIP",
    guestCount: 2,
    rsvpStatus: "confirmed",
    mealPreference: "Vegetarian",
    roomAllocation: "Suite 301",
    transportRequired: false,
    transportDetails: "",
    notes: "Family doctor. Reserved special seating."
  },
  {
    id: "g9",
    name: "Arjun Reddy",
    email: "arjun@email.com",
    phone: "+91 98765 43218",
    side: "Friends",
    guestCount: 4,
    rsvpStatus: "pending",
    mealPreference: "Non-Vegetarian",
    roomAllocation: "",
    transportRequired: false,
    transportDetails: "",
    notes: "College friends group."
  },
  {
    id: "g10",
    name: "Meera Iyer",
    email: "meera@email.com",
    phone: "+91 98765 43219",
    side: "Relatives",
    guestCount: 3,
    rsvpStatus: "confirmed",
    mealPreference: "Vegetarian",
    roomAllocation: "Deluxe 205",
    transportRequired: true,
    transportDetails: "Airport pickup on Dec 13 evening",
    notes: "Aunt's family from Bangalore."
  }
];

// TASKS MODULE
export const mockTasks = [
  {
    id: "t1",
    title: "Bride Entry Coordination",
    description: "Coordinate with DJ and lighting team for bride's grand entry. Plan phoolon ki chaadar timing.",
    dueDate: "2025-12-14",
    priority: "high",
    status: "todo",
    assignedTo: "Priya Sharma",
    attachments: [],
    notes: "DJ to play 'Mere Haath Mein' song"
  },
  {
    id: "t2",
    title: "Confirm Mandap Decoration",
    description: "Final check with decorator for mandap flowers and draping.",
    dueDate: "2025-12-13",
    priority: "high",
    status: "todo",
    assignedTo: "Rahul Kapoor",
    attachments: [],
    notes: "Red and gold theme confirmed"
  },
  {
    id: "t3",
    title: "Guest List Finalization",
    description: "Get final RSVP count and send to caterer.",
    dueDate: "2025-12-10",
    priority: "medium",
    status: "todo",
    assignedTo: "Anjali Singh",
    attachments: [],
    notes: "Deadline approaching"
  },
  {
    id: "t4",
    title: "Mehendi Artist Arrival",
    description: "Confirm arrival time and setup location for mehendi artist.",
    dueDate: "2025-12-13",
    priority: "high",
    status: "in-progress",
    assignedTo: "Priya Sharma",
    attachments: [],
    notes: "Artist coming from Jaipur"
  },
  {
    id: "t5",
    title: "Photography Shot List",
    description: "Prepare must-have shot list for photographer.",
    dueDate: "2025-12-14",
    priority: "medium",
    status: "in-progress",
    assignedTo: "Karan Mehta",
    attachments: [],
    notes: "Family group photos priority"
  },
  {
    id: "t6",
    title: "Sound System Check",
    description: "Test all microphones and speakers at venue.",
    dueDate: "2025-12-14",
    priority: "high",
    status: "in-progress",
    assignedTo: "Rahul Kapoor",
    attachments: [],
    notes: "Backup equipment ready"
  },
  {
    id: "t7",
    title: "Wedding Rings Delivery",
    description: "Waiting for jeweler to deliver wedding rings.",
    dueDate: "2025-12-12",
    priority: "high",
    status: "blocked",
    assignedTo: "Unassigned",
    attachments: [],
    notes: "Jeweler having design issue"
  },
  {
    id: "t8",
    title: "Backup Generator Test",
    description: "Power backup generator testing blocked due to vendor delay.",
    dueDate: "2025-12-13",
    priority: "medium",
    status: "blocked",
    assignedTo: "Rahul Kapoor",
    attachments: [],
    notes: "Vendor coming tomorrow"
  },
  {
    id: "t9",
    title: "Bridal Outfit Fitting",
    description: "Final fitting and alterations for bridal lehenga.",
    dueDate: "2025-11-30",
    priority: "high",
    status: "done",
    assignedTo: "Priya Sharma",
    attachments: [],
    notes: "Perfect fit. Packed and ready."
  },
  {
    id: "t10",
    title: "Wedding Card Distribution",
    description: "Distribute physical invitation cards to local guests.",
    dueDate: "2025-11-28",
    priority: "medium",
    status: "done",
    assignedTo: "Anjali Singh",
    attachments: [],
    notes: "All cards delivered"
  },
  {
    id: "t11",
    title: "Venue Advance Payment",
    description: "Paid final advance to venue management.",
    dueDate: "2025-11-25",
    priority: "high",
    status: "done",
    assignedTo: "Karan Mehta",
    attachments: [],
    notes: "Receipt collected"
  },
  {
    id: "t12",
    title: "Guest Room Blocks",
    description: "Booked 50 rooms for out-of-town guests.",
    dueDate: "2025-11-20",
    priority: "medium",
    status: "done",
    assignedTo: "Anjali Singh",
    attachments: [],
    notes: "Discounted rate secured"
  }
];

// EMERGENCY CHECKLISTS
export const emergencyChecklists = [
  {
    id: "e1",
    type: "Vendor No-Show",
    icon: "🚨",
    description: "Critical vendor has not arrived or is unreachable",
    isActive: false,
    activatedAt: null,
    checklist: [
      { id: "e1-1", task: "Call vendor immediately using all contact numbers", completed: false },
      { id: "e1-2", task: "Check backup vendor list and availability", completed: false },
      { id: "e1-3", task: "Contact backup vendor and negotiate emergency rate", completed: false },
      { id: "e1-4", task: "Notify team members and assign replacement coordination", completed: false },
      { id: "e1-5", task: "Inform client about situation and solution", completed: false },
      { id: "e1-6", task: "Adjust timeline and notify other vendors if needed", completed: false }
    ]
  },
  {
    id: "e2",
    type: "Weather Emergency (Rain Plan)",
    icon: "🌧️",
    description: "Unexpected rain or bad weather threatening outdoor events",
    isActive: false,
    activatedAt: null,
    checklist: [
      { id: "e2-1", task: "Activate indoor venue backup immediately", completed: false },
      { id: "e2-2", task: "Coordinate moving décor and furniture indoors", completed: false },
      { id: "e2-3", task: "Notify all guests via WhatsApp/SMS about venue change", completed: false },
      { id: "e2-4", task: "Check tent/shamiana availability for partial cover", completed: false },
      { id: "e2-5", task: "Rearrange seating plan for indoor space", completed: false },
      { id: "e2-6", task: "Test indoor sound system and lighting", completed: false },
      { id: "e2-7", task: "Ensure pathway is covered and slip-proof", completed: false }
    ]
  },
  {
    id: "e3",
    type: "Baraat Delay",
    icon: "🎺",
    description: "Groom's baraat is significantly delayed",
    isActive: false,
    activatedAt: null,
    checklist: [
      { id: "e3-1", task: "Contact baraat coordinator for ETA and reason", completed: false },
      { id: "e3-2", task: "Notify bride's family and manage expectations", completed: false },
      { id: "e3-3", task: "Adjust ceremony timing and inform pandit/priest", completed: false },
      { id: "e3-4", task: "Inform caterer to hold food service or adjust timing", completed: false },
      { id: "e3-5", task: "Keep entertainment running (DJ/band) to engage guests", completed: false },
      { id: "e3-6", task: "Arrange refreshments for waiting guests", completed: false },
      { id: "e3-7", task: "Update photographer about new timeline", completed: false }
    ]
  },
  {
    id: "e4",
    type: "Missing Critical Items",
    icon: "📦",
    description: "Essential items (rings, garlands, props) are missing",
    isActive: false,
    activatedAt: null,
    checklist: [
      { id: "e4-1", task: "Identify exactly what items are missing", completed: false },
      { id: "e4-2", task: "Check backup supplies and storage areas", completed: false },
      { id: "e4-3", task: "Send team member to purchase replacements immediately", completed: false },
      { id: "e4-4", task: "Contact nearby vendors for emergency supply", completed: false },
      { id: "e4-5", task: "Implement creative workaround if item cannot be found", completed: false },
      { id: "e4-6", task: "Brief team on how to handle situation discreetly", completed: false }
    ]
  },
  {
    id: "e5",
    type: "Schedule Overrun",
    icon: "⏰",
    description: "Events are running significantly behind schedule",
    isActive: false,
    activatedAt: null,
    checklist: [
      { id: "e5-1", task: "Identify which event is causing the delay", completed: false },
      { id: "e5-2", task: "Compress or combine remaining non-critical events", completed: false },
      { id: "e5-3", task: "Notify all vendors of revised timing", completed: false },
      { id: "e5-4", task: "Update timeline and communicate to team", completed: false },
      { id: "e5-5", task: "Brief MC/host to speed up announcements", completed: false },
      { id: "e5-6", task: "Inform key guests about adjusted schedule", completed: false },
      { id: "e5-7", task: "Ensure photographer captures all must-have shots", completed: false }
    ]
  }
];

// MOODBOARDS MODULE
export const mockMoodboards = [
  {
    id: "m1",
    eventName: "Sangeet Décor",
    description: "Gold and red theme with fairy lights, marigold flowers, and traditional draping. Bollywood vibes with dance floor lighting.",
    images: [
      "https://images.unsplash.com/photo-1519741497674-611481863552?w=400",
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=400",
      "https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=400",
      "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=400"
    ],
    referenceLinks: "Pinterest: /sangeet-gold-red\nInstagram: @weddingdecor",
    status: "approved",
    approvedAt: "2025-12-01",
    createdAt: "2025-11-15"
  },
  {
    id: "m2",
    eventName: "Wedding Mandap",
    description: "Traditional mandap with white and pink roses, crystal hangings, and elegant draping. Royal and sophisticated look.",
    images: [
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=400",
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=400",
      "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=400"
    ],
    referenceLinks: "Pinterest: /mandap-white-pink",
    status: "pending",
    approvedAt: null,
    createdAt: "2025-11-20"
  },
  {
    id: "m3",
    eventName: "Reception Stage",
    description: "Modern minimalist stage with LED backdrop, floral arch, and elegant seating. Contemporary meets traditional.",
    images: [
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400",
      "https://images.unsplash.com/photo-1523438097201-512ae7d59c44?w=400"
    ],
    referenceLinks: "Instagram: @receptiondecor",
    status: "pending",
    approvedAt: null,
    createdAt: "2025-11-22"
  },
  {
    id: "m4",
    eventName: "Mehendi Setup",
    description: "Colorful low seating with cushions, umbrellas, marigold decorations. Vibrant and cheerful Indian theme.",
    images: [
      "https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=400",
      "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=400",
      "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=400"
    ],
    referenceLinks: "",
    status: "approved",
    approvedAt: "2025-11-25",
    createdAt: "2025-11-10"
  },
  {
    id: "m5",
    eventName: "Bridal Look",
    description: "Traditional red and gold bridal lehenga with heavy jewelry. Classic north Indian bride look.",
    images: [
      "https://images.unsplash.com/photo-1595072009795-25e689f8fd53?w=400",
      "https://images.unsplash.com/photo-1585800191331-c274c7dba10a?w=400"
    ],
    referenceLinks: "Instagram: @bridallooks",
    status: "approved",
    approvedAt: "2025-11-05",
    createdAt: "2025-10-20"
  }
];

// MEDIA/ALBUMS MODULE
export const mockAlbums = [
  {
    id: "a1",
    name: "Mehendi Ceremony",
    eventDate: "2025-12-10",
    description: "Traditional mehendi with family and friends. Colorful decorations and joyful moments.",
    photographerName: "Dreamlight Photography",
    photoCount: 156,
    videoCount: 12,
    thumbnails: [
      "https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=300",
      "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=300",
      "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=300",
      "https://images.unsplash.com/photo-1519741497674-611481863552?w=300"
    ],
    createdAt: "2025-12-10"
  },
  {
    id: "a2",
    name: "Sangeet Night",
    eventDate: "2025-12-11",
    description: "Dance performances, music, and entertainment. Bollywood theme with DJ and live band.",
    photographerName: "Dreamlight Photography",
    photoCount: 243,
    videoCount: 18,
    thumbnails: [
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=300",
      "https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=300",
      "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=300",
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=300"
    ],
    createdAt: "2025-12-11"
  },
  {
    id: "a3",
    name: "Haldi Ceremony",
    eventDate: "2025-12-12",
    description: "Traditional turmeric application ceremony with family. Yellow theme decorations.",
    photographerName: "Moments by Ravi",
    photoCount: 98,
    videoCount: 8,
    thumbnails: [
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=300",
      "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=300",
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=300"
    ],
    createdAt: "2025-12-12"
  },
  {
    id: "a4",
    name: "Wedding Ceremony",
    eventDate: "2025-12-13",
    description: "Main wedding rituals, pheras, and ceremonies. Traditional mandap with family blessings.",
    photographerName: "Dreamlight Photography",
    photoCount: 312,
    videoCount: 25,
    thumbnails: [
      "https://images.unsplash.com/photo-1519741497674-611481863552?w=300",
      "https://images.unsplash.com/photo-1523438097201-512ae7d59c44?w=300",
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=300",
      "https://images.unsplash.com/photo-1585800191331-c274c7dba10a?w=300"
    ],
    createdAt: "2025-12-13"
  },
  {
    id: "a5",
    name: "Reception Party",
    eventDate: "2025-12-14",
    description: "Grand reception with cake cutting, couple's dance, and guest celebrations.",
    photographerName: "Dreamlight Photography",
    photoCount: 187,
    videoCount: 15,
    thumbnails: [
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=300",
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=300",
      "https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=300"
    ],
    createdAt: "2025-12-14"
  },
  {
    id: "a6",
    name: "Getting Ready",
    eventDate: "2025-12-13",
    description: "Bride and groom getting ready shots. Behind the scenes moments.",
    photographerName: "Moments by Ravi",
    photoCount: 76,
    videoCount: 5,
    thumbnails: [
      "https://images.unsplash.com/photo-1595072009795-25e689f8fd53?w=300",
      "https://images.unsplash.com/photo-1585800191331-c274c7dba10a?w=300"
    ],
    createdAt: "2025-12-13"
  },
  {
    id: "a7",
    name: "Couple Portraits",
    eventDate: "2025-12-13",
    description: "Romantic couple shots at scenic locations. Candid and posed photography.",
    photographerName: "Dreamlight Photography",
    photoCount: 124,
    videoCount: 3,
    thumbnails: [
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=300",
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=300",
      "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=300"
    ],
    createdAt: "2025-12-13"
  }
];

// MENU MODULE
export const mockMenuItems = [
  {
    id: "m1",
    eventName: "Sangeet",
    course: "Starter",
    itemName: "Paneer Tikka",
    description: "Spiced cottage cheese cubes grilled to perfection",
    dietaryInfo: "Vegetarian"
  },
  {
    id: "m2",
    eventName: "Sangeet",
    course: "Starter",
    itemName: "Chicken Seekh Kebab",
    description: "Minced chicken with aromatic spices",
    dietaryInfo: "Non-Vegetarian"
  },
  {
    id: "m3",
    eventName: "Sangeet",
    course: "Main Course",
    itemName: "Butter Chicken",
    description: "Creamy tomato gravy with tender chicken pieces",
    dietaryInfo: "Non-Vegetarian"
  },
  {
    id: "m4",
    eventName: "Sangeet",
    course: "Main Course",
    itemName: "Dal Makhani",
    description: "Black lentils cooked overnight with butter and cream",
    dietaryInfo: "Vegetarian"
  },
  {
    id: "m5",
    eventName: "Sangeet",
    course: "Dessert",
    itemName: "Gulab Jamun",
    description: "Deep-fried milk solids in rose-flavored sugar syrup",
    dietaryInfo: "Vegetarian"
  },
  {
    id: "m6",
    eventName: "Wedding Ceremony",
    course: "Starter",
    itemName: "Samosa Chaat",
    description: "Crispy samosas topped with yogurt and chutneys",
    dietaryInfo: "Vegetarian"
  },
  {
    id: "m7",
    eventName: "Wedding Ceremony",
    course: "Main Course",
    itemName: "Biryani",
    description: "Fragrant basmati rice with vegetables and spices",
    dietaryInfo: "Vegetarian"
  },
  {
    id: "m8",
    eventName: "Wedding Ceremony",
    course: "Dessert",
    itemName: "Ras Malai",
    description: "Soft paneer dumplings in sweetened milk",
    dietaryInfo: "Vegetarian"
  }
];

// TIMELINE/EVENTS MODULE
export const mockTimelineEvents = [
  {
    id: "e1",
    name: "Mehendi Ceremony",
    date: "2025-12-13",
    startTime: "14:00",
    endTime: "18:00",
    venue: "Hotel Garden Lawn",
    description: "Traditional mehendi ceremony with music and snacks",
    status: "upcoming"
  },
  {
    id: "e2",
    name: "Sangeet Night",
    date: "2025-12-13",
    startTime: "20:00",
    endTime: "23:30",
    venue: "Grand Ballroom",
    description: "Dance performances, DJ, and dinner",
    status: "upcoming"
  },
  {
    id: "e3",
    name: "Haldi Ceremony",
    date: "2025-12-14",
    startTime: "09:00",
    endTime: "11:00",
    venue: "Home - Bride's Side",
    description: "Traditional turmeric application ceremony",
    status: "upcoming"
  },
  {
    id: "e4",
    name: "Wedding Ceremony",
    date: "2025-12-15",
    startTime: "10:00",
    endTime: "14:00",
    venue: "The Grand Palace, Mumbai",
    description: "Main wedding rituals and pheras",
    status: "upcoming"
  },
  {
    id: "e5",
    name: "Reception Party",
    date: "2025-12-15",
    startTime: "19:00",
    endTime: "23:00",
    venue: "The Grand Palace, Mumbai",
    description: "Grand reception with dinner and celebrations",
    status: "upcoming"
  }
];

// MEDIA/ALBUMS ALIAS
export const mockMediaAlbums = mockAlbums;

// Module data accessor functions
export const mockModulesData = {
  getGuests: (weddingId) => mockGuests,
  getTasks: (weddingId) => mockTasks,
  getTimelineEvents: (weddingId) => mockTimelineEvents,
  getMediaAlbums: (weddingId) => mockMediaAlbums,
  getMenuItems: (weddingId) => mockMenuItems
};
